import { DialogActions, DialogContent } from '@mui/material'

import { DialogRoot } from './dialog-root'
import { DialogTitle } from './dialog-title'

export const Dialog = Object.assign(DialogRoot, {
  Title: DialogTitle,
  Content: DialogContent,
  Actions: DialogActions,
})
